import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * The patient's prescription verification — the record behind legacy's
 * "Verify Patient" dialog (bridge new-bridge/components/PatientTrackingStatus.js,
 * via PatientsService.getPrescription / verifyPrescription).
 *
 *   GET  /patients/{id}/verify -> { status, comment, doctor }
 *        404 "Prescription is not available" while the patient has no record;
 *        422 when the referring doctor cannot be read.
 *   PUT  /patients/{id}/verify   { status, commentType } -> { status, comment, … }
 *        needs an existing record (422 otherwise).
 *
 * status  0 pending · 1 successful · 2 unsuccessful · 3 wrong document
 * comment 1 doctor as per code · 2 doctor not as per code · 3 wrong document
 * (api-user-service models/prescription_verification.go).
 *
 * The same file exists in bridge-frontend; the two differ only in where
 * APIConfig is imported from.
 */
export default class PrescriptionVerificationService {
  constructor() {
    this.api = new APIService();
  }

  get(patientId, onResponse, onError) {
    return this.api.get(APIConfig.prescriptionVerification.get.format(patientId), onResponse, onError);
  }

  update(patientId, status, commentType, onResponse, onError) {
    return this.api.put(
      APIConfig.prescriptionVerification.update.format(patientId),
      { status, commentType },
      onResponse,
      onError
    );
  }
}
